// extracted by mini-css-extract-plugin
export default {"buttonBlack":"ButtonBlack_buttonBlack__PRpAk"};